import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  ListGroup,
  Spinner,
  Image,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ArrowIcon from "./ArrowIcon";
import { Icon } from "@iconify/react";
import { softwareListing } from "api/CategoryService"; // 👈 Define these API functions
import { fetchCategoryProducts } from "api/ProductService";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

import IMAGES from "../constants/images";
import RatingStars from "./RatingStars";
import { useAuth } from "context/UserContext";
import { Sentry } from "react-activity";
import { toast } from "react-toastify";
import Loader from "./Loader";

const CategoriesComponent = () => {
  const navigate = useNavigate();
  const productSectionRef = useRef(null);
  const { user, isLoggedIn } = useAuth();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageLoaded, setPageLoaded] = useState(true);

  // 🔹 Fetch categories on mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await softwareListing();
        if (res.success) {
          setCategories(res.body.data);
          setSelectedCategory(res.body.data[0]?._id);
        }
      } catch (err) {
        console.error("Failed to fetch categories", err);
      }
    };
    fetchCategories();
  }, []);

  // 🔹 Fetch products when category changes
  useEffect(() => {
    if (selectedCategory) {
      fetchProducts(selectedCategory);
    }
  }, [selectedCategory]);

  const fetchProducts = async (catId) => {
    try {
      setLoading(true);

      const res = await fetchCategoryProducts({ catId });
      if (res.success) {
        setProducts(res.body.data);
        scrollToProductList();
      }
    } catch (err) {
      console.error("Error loading products", err);
    } finally {
      setLoading(false);
      setPageLoaded(false);
    }
  };

  const scrollToProductList = () => {
    setTimeout(() => {
      // if (productSectionRef.current) {
      //   const yOffset = -50;
      //   const y =
      //     productSectionRef.current.getBoundingClientRect().top +
      //     window.pageYOffset +
      //     yOffset;
      //   window.scrollTo({ top: y, behavior: "smooth" });
      // }
    }, 100);
  };

  if (pageLoaded) {
    return (
      <div className="text-center py-5 d-flex justify-content-center align-items-center product-loading">
        {/* <Loader  style={{width: 100, height: 100}} /> */}
        <Sentry color="#e91515" size={40} speed={1} animating={true} />
      </div>
    );
  }

  return (
    <Container fluid className="py-4">
      <Row>
        {/* Sidebar */}
        <Col sm={4} md={4} lg={3} className="mb-4">
          <div className="stickyPos">
            {!pageLoaded && (
              <div className="header_profile2">
                <div className="d-flex justify-content-between align-items-center mb-4 ">
                  <h3 className="mb-0  ">Software</h3>
                  <div
                    className="d-flex align-items-center gap-2"
                    style={{
                      cursor: "pointer",
                      color: "#e91515",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                    onClick={() => navigate("/software")}
                  >
                    See All Softwares{" "}
                    <Icon
                      icon="solar:arrow-right-linear"
                      fontSize={20}
                      className=""
                    />
                  </div>
                </div>
              </div>
            )}
            {!pageLoaded && (
              <div className="header_profile3 w-100">
                <ListGroup
                  className=""
                  style={{ borderRadius: "10px", width: "100%" }}
                >
                  {categories.map((category, index) => (
                    <ListGroup.Item
                      key={index}
                      onClick={() => setSelectedCategory(category._id)}
                      className={
                        selectedCategory === category._id ? "active" : ""
                      }
                      style={{
                        cursor: "pointer",
                        borderColor:
                          selectedCategory === category._id
                            ? "#E91515"
                            : "#ddd",
                        backgroundColor:
                          selectedCategory === category._id
                            ? "#E91515"
                            : "#fff",
                        color:
                          selectedCategory === category._id ? "#fff" : "#000",
                      }}
                    >
                      {category.title}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </div>
            )}

            <div
              className="header_profile2 d-flex justify-content-between gap-4 align-items-center w-100"
              style={{ overflow: "auto" }}
            >
              {categories?.map((category, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedCategory(category._id)}
                  className={`${
                    selectedCategory === category._id ? "active" : ""
                  }`}
                  style={{
                    padding: "6px 8px",

                    minWidth: "fit-content",
                    cursor: "pointer",
                    border: "1px solid #ddd",
                    borderRadius: "10px",
                    backgroundColor:
                      selectedCategory === category._id ? "#E91515" : "#fff",
                    color: selectedCategory === category._id ? "#fff" : "#000",
                  }}
                >
                  {category.title}
                </div>
              ))}
            </div>
            {!pageLoaded && (
              <Button
                variant="outline-primary header_profile3"
                as={Link}
                className="mt-3 w-100 iconFlex"
                to="/software"
              >
                See All Softwares <ArrowIcon />
              </Button>
            )}
          </div>
        </Col>

        {/* Product Cards */}
        <Col sm={8} md={8} lg={9}>
          <Row ref={productSectionRef} className="gy-4">
            {loading ? (
              <div
                style={{ minHeight: "60vh"}}
                className="text-center py-5 d-flex justify-content-center align-items-center"
              >
                <Sentry color="#e91515" size={40} speed={1} animating={true} />
                {/* <Loader  style={{width: 100, height: 100}} /> */}
              </div>
            ) : products.length === 0 ? (
              <Col
                md={12}
                className="text-center py-5"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Image
                  src={IMAGES.emptyState}
                  alt=""
                  height="50%"
                  width="50%"
                  className="mb-4"
                />
                <h5 className="text-muted" style={{ fontSize: "16px" }}>
                  No products found for this category.
                </h5>
              </Col>
            ) : (
              products.slice(0, 9)?.map((product, index) => (
                <Col
                  xs={6}
                  sm={6}
                  md={6}
                  lg={4}
                  key={index}
                  className="mb-4 home"
                >
                  <Card className="product-card">
                    <div
                      onClick={() =>
                        navigate(`/product-details/${product.slug}`)
                      }
                      className="product-icon-box"
                      style={{
                        cursor: "pointer",
                        backgroundColor: product.brandColors || "#f5f5f5",
                      }}
                    >
                      <img
                        src={product.logoUrl}
                        alt={product.name}
                        className="product-icon-img"
                      />
                    </div>
                    <Card.Body className="product-card-body">
                      <div>
                        <Link
                          to={`/product-details/${product.slug}`}
                          className="mb-1 text-dark product-card-link"
                        >
                          <Card.Title className="truncate-2-lines my-1 product-card-title">
                            {product.name}
                          </Card.Title>
                        </Link>
                        <Card.Text className="product-card-text">
                          <RatingStars rating={product.avgRating || 0} />
                          <div className="total_review_text">
                            ({product.totalReviews || 0})
                          </div>
                        </Card.Text>
                      </div>
                      {(!user || user.role === "user") && (
                        <Button
                          className="product-card-review-btn"
                          onClick={() => {
                            if (!isLoggedIn) {
                              toast.error("Please login to write a review", {
                                toastId: "login-required",
                              });
                              return;
                            }
                            navigate("/write-a-review");
                            localStorage.setItem("step", 2);
                            localStorage.setItem(
                              "checkedProducts",
                              JSON.stringify([product])
                            );
                          }}
                          variant="danger"
                          size="sm"
                        >
                          Write A Review
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))
            )}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default CategoriesComponent;
